import * as React from 'react';
import classNames from 'classnames';

import { DynamicMediaItem, View } from '@uncinc/react-drupal-core';
import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';
import { Container, WysiwygField } from '@uncinc/uncinc-react-kitchen-sink';
import { useTranslation } from 'react-i18next';

import { TaxonomyTheme } from '../../../../types/uncinc_profile/taxonomy';
import { Breadcrumbs, ParagraphsRenderer } from '../../../../components';

import {
  DEFAULT_LANGUAGE,
} from '../../../../config/constants';

import './style.scss';

interface TaxonomyThemePageProps {
  entity: ImmutableEntity<TaxonomyTheme>;
}

const TaxonomyThemePage: React.FC<TaxonomyThemePageProps> = ({ entity }) => {
  const { t } = useTranslation();
  const classes = classNames('Taxonomy Taxonomy-type-breadcrumbs TaxonomyTheme');
  const taxonomy = entity.toJS();
  const tid = taxonomy.tid[0].value;
  const name = taxonomy.name[0].value;
  const body = taxonomy.description[0].value;
  const lang = taxonomy.langcode[0].value || DEFAULT_LANGUAGE;
  const labelIds = taxonomy.field_labels.map((label) => label.target_id);
  const heroImage = taxonomy.field_media_item[0];

  return (
    <article itemType="http://schema.org/WebPage" className={classes}>
      <Container>
        <div className="row">
          <div className="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2">
            <Breadcrumbs
              currentPage={name}
              parentTitle={t('taxonomies.theme.title')}
              parentLink={`/${lang}/${t('taxonomies.theme.title').toLowerCase()}`}
            />
            <h1 className="TaxonomyTheme__title">{name}</h1>
            <WysiwygField html={body} className="TaxonomyTheme__body" />
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            {heroImage && (
              <DynamicMediaItem
                className="TaxonomyTheme__image"
                media={heroImage}
                imageAspectRatio="16_9"
              />
            )}
          </div>
        </div>
      </Container>

      <ParagraphsRenderer paragraphs={entity.get('field_paragraphs')} />

      <Container>
        <View
          id="projects_filtered"
          display="related"
          filters={{
            field_themes_target_id: [tid],
            field_labels_target_id: labelIds.length > 0 ? labelIds.join('+') : [],
          }}
        />
      </Container>

    </article>
  );
};

export default TaxonomyThemePage;
